module.exports = __webpack_public_path__ + "media/images/icon_list/external_link-20f5d61889edc9b9fb3c4163a91eea31.svg";